export interface GtmType {
    id: number;
    title: string;
    defaultIconId: number;
}

export interface ContourData {
    field_id: number;
    stratum_id: number;
    stratum_name: string;
    contour_type_id: number;
    contour_type_name: string;
    contour_id: number;
    contour_name: string;
    visible: boolean;
    brush_color: string;
    brush_visible: boolean;
    marker_visible: boolean;
    pen_color: string;
    pen_style: number; // 1-линия // 2-пунктир // 3-точки // 4-пунктир с точкой // 5-пунктир с двумя точками
    pen_visible: true;
    pen_width: number;
}

export interface ShapeFile {
    id: string;
    title: string;
    owner: string;
}

export interface ShapeFileWasm {
    id: number;
    file_name: string;
    visible?: boolean;
}

export enum PREPARE_STATUS {
    IDLE,
    SELECT_STRATUMS,
    SELECT_VERSIONS,
    FINISH,
}

export enum CURSOR_MODE {
    VIEWING,
    RULER,
    USER_CIRCLE,
    LASSO,
    CIRCLE,
    OVAL,
    CHAIN,
}

export enum MODALS {
    STRATUMS,
    VERSIONS,
    ADD_LAYER,
    COLOR_PICKER,
    TEMPLATES,
    SHAPE,
}

export const WELL_BUILD_TYPES = [
    {
        id: 0,
        title: 'по пластам',
    },
    {
        id: 1,
        title: 'по устью',
    },
    {
        id: 2,
        title: 'по забоям',
    },
];
